import React from 'react';

import { DRAWER_TABS_V3 } from '../drawer-tabs-v3';
import { useProductDetailsContext } from '../../use-product-details-context';
import { useIsUnitsOfMeasureAvailable } from '../../../../feature-gates/use-is-units-of-measure-available';
import { useIsProductInventorySyncTabAvailable } from '../../../../feature-gates/use-is-product-inventory-sync-tab-available';

const DEFAULT_TAB = DRAWER_TABS_V3[0];
const UOM_TAB_ID = 'product-units-of-measure';
const INVENTORY_SYNC_TAB_ID = 'product-inventory-sync';

export const ProductDetailsDrawerContent = () => {
  const { selectedTab } = useProductDetailsContext();
  const { isLdEnabled } = useIsUnitsOfMeasureAvailable();
  const isProductInventorySyncTabEnabled = useIsProductInventorySyncTabAvailable();

  const activeTab =
    DRAWER_TABS_V3.find(
      (tab) =>
        tab.id === selectedTab &&
        (tab.id !== UOM_TAB_ID || isLdEnabled) &&
        (tab.id !== INVENTORY_SYNC_TAB_ID || isProductInventorySyncTabEnabled),
    ) ?? DEFAULT_TAB;

  return <>{activeTab.render()}</>;
};
